var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { IconButton } from './icon-button';
import { DocumentSmallIconGlyph, PictureFileIconGlyph } from '@shapeable/icons';
import { useDialogs } from '../hooks/use-dialogs';
import { EntityCreateDialog } from '../entities/entity-create-dialog';
import { useLang } from '../hooks/use-lang';
var cls = classNames('attachment-picker');
// -------- Types -------->
export var IMAGE_ENTITY_FIELDS = [{
  label: "Name",
  description: "",
  ownDescription: "",
  name: "name",
  type: "text",
  formFieldType: "text",
  required: true,
  entityTypeName: "",
  entityTypeNamePlural: ""
}, {
  label: "Image",
  description: "Upload or enter a URL to an Image",
  ownDescription: "",
  name: "image",
  type: "image",
  formFieldType: "image",
  required: true,
  entityTypeName: "",
  entityTypeNamePlural: ""
}];
export var FILE_ENTITY_FIELDS = [{
  label: "Name",
  description: "",
  ownDescription: "",
  name: "name",
  type: "text",
  formFieldType: "text",
  required: true,
  entityTypeName: "",
  entityTypeNamePlural: ""
}, {
  label: "File",
  description: "Choose or link to a file online",
  ownDescription: "",
  name: "file",
  type: "file",
  formFieldType: "file",
  required: true,
  entityTypeName: "",
  entityTypeNamePlural: ""
}];
export var AttachmentPickerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: ", " ", ";\n  border-radius: ", ";\n  background: ", ";\n  box-shadow: 2px 8px 8px 0 ", ";\n  min-width: 170px;\n  "], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: ", " ", ";\n  border-radius: ", ";\n  background: ", ";\n  box-shadow: 2px 8px 8px 0 ", ";\n  min-width: 170px;\n  "])), theme.UNIT(2), theme.UNIT(1), theme.UNIT(2), theme.COLOR('#E9E9E9'), theme.COLOR('very-subtle'))
});
var IconButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    padding: ", " ", ";\n    align-self: stretch;\n    color: ", ";\n    font-size: 1em;\n    font-weight: 500;\n    text-transform: uppercase;\n    border-bottom: 1px solid ", ";\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    padding: ", " ", ";\n    align-self: stretch;\n    color: ", ";\n    font-size: 1em;\n    font-weight: 500;\n    text-transform: uppercase;\n    border-bottom: 1px solid ", ";\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])), theme.UNIT(2), theme.UNIT(2), theme.COLOR('text'), theme.COLOR('line-very-subtle'))
});
var DialogStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'AttachmentPicker',
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SelectionItem: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconLabel: styled(IconButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconButtonStyles),
  Dialog: styled(EntityCreateDialog)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles)
};
export var AttachmentPicker = function (props) {
  var _a = useComponentProps(My.NAME, props, AttachmentPickerDefaultProps),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    entityTypeNames = _a.entityTypeNames,
    onEntityCreated = _a.onEntityCreated;
  var dialogs = useDialogs();
  var t = useLang();
  ;
  var onEditClick = function (entity, customFields) {
    dialogs.push(React.createElement(My.Dialog, {
      entityType: entity,
      customFields: customFields,
      onEntityCreated: function (createdEntity) {
        if (onEntityCreated) {
          onEntityCreated(createdEntity);
        }
      }
    }));
  };
  var onEntityUploadClick = function (event, entity, customFields) {
    event.stopPropagation();
    event.preventDefault();
    onEditClick(entity, customFields);
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.IconLabel, {
    onClick: function (e) {
      return onEntityUploadClick(e, 'ImageAsset', IMAGE_ENTITY_FIELDS);
    },
    iconColor: 'text',
    iconSize: 20,
    icon: React.createElement(PictureFileIconGlyph, null)
  }, t('Image')), React.createElement(My.IconLabel, {
    onClick: function (e) {
      return onEntityUploadClick(e, 'FileAsset', FILE_ENTITY_FIELDS);
    },
    iconColor: 'text',
    iconSize: 20,
    icon: React.createElement(DocumentSmallIconGlyph, null)
  }, t('File')), children);
};
AttachmentPicker.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;